import styled from "styled-components";

export const AccountChartStyle = styled.div`
  .chartheading {
    display: flex;
    justify-content: center;
    font-family: thin-pro, sans-serif;
    font-weight: 700;
    font-size: 20px;
  }
  .chartdiv {
    width: 300px; /* Set the desired width */
    height: 300px; /* Set the desired height */
    margin: 20px auto;
    display: flex;
    justify-content: center;
    font-family: thin-pro, sans-serif;
  }
`;
